// Phase 21 · Speaker stage card (audio room)
import React, { useState, useEffect } from "react";
import { Mic, MicOff, Crown } from "lucide-react";
import FakeWaveform from "./FakeWaveform";

export default function SpeakerStageCard({ p, isHostView, onDemote, onToggleMute }) {
    // UI-only fake talking indicator — pulses at random intervals for demo effect.
    const [talking, setTalking] = useState(false);
    useEffect(() => {
        if (p.is_muted_ui) { setTalking(false); return; }
        let t;
        const cycle = () => {
            const on = Math.random() > 0.5;
            setTalking(on);
            t = setTimeout(cycle, 1500 + Math.random() * 2500);
        };
        cycle();
        return () => clearTimeout(t);
    }, [p.is_muted_ui]);

    const isHostRole = p.role === "host";

    return (
        <div
            className={`flex flex-col items-center gap-2 p-4 rounded-2xl border transition-all ${talking && !p.is_muted_ui ? "border-[#FFFFFF]/70 bg-[#FFFFFF]/10 shadow-[0_0_28px_rgba(255, 255, 255,0.35)]" : "border-[#1A1A1A] bg-[#111111]"}`}
            data-testid={`speaker-tile-${p.user_id}`}
        >
            <div className="relative">
                <div className={`w-16 h-16 rounded-full bg-white flex items-center justify-center text-neutral-900 font-bold text-lg ${talking && !p.is_muted_ui ? "ring-4 ring-[#FFFFFF]/40" : ""}`}>
                    {p.username?.[0]?.toUpperCase() || "?"}
                </div>
                {isHostRole && (
                    <div className="absolute -top-1 -right-1 bg-[#A3A3A3] rounded-full p-1" title="Host">
                        <Crown size={10} className="text-white" />
                    </div>
                )}
                {p.is_muted_ui && (
                    <div className="absolute -bottom-1 -right-1 bg-[#FAFAFA] rounded-full p-1">
                        <MicOff size={10} className="text-white" />
                    </div>
                )}
                {!p.is_muted_ui && talking && (
                    <div className="absolute -bottom-1 -right-1 bg-[#CCCCCC] rounded-full p-1 animate-pulse">
                        <Mic size={10} className="text-white" />
                    </div>
                )}
            </div>
            <div className="text-center">
                <p className="text-xs font-semibold text-neutral-100">@{p.username}</p>
                <p className="text-[10px] text-neutral-500 capitalize">{p.role}</p>
            </div>
            <FakeWaveform active={talking && !p.is_muted_ui} color={p.is_muted_ui ? "#FAFAFA" : "#FFFFFF"} />
            {isHostView && p.role === "speaker" && (
                <div className="flex items-center gap-1 mt-1">
                    <button
                        type="button"
                        onClick={() => onToggleMute?.(p)}
                        className="text-[10px] px-2 py-1 rounded-lg border border-[#1A1A1A] hover:border-[#A3A3A3]/40 hover:text-[#A3A3A3] text-neutral-400"
                        data-testid={`mute-${p.user_id}`}
                    >
                        {p.is_muted_ui ? "Unmute" : "Mute"}
                    </button>
                    <button
                        type="button"
                        onClick={() => onDemote?.(p)}
                        className="text-[10px] px-2 py-1 rounded-lg bg-[#FAFAFA]/10 border border-[#FAFAFA]/40 hover:bg-[#FAFAFA]/20 text-[#FAFAFA]"
                        data-testid={`demote-${p.user_id}`}
                    >
                        Demote
                    </button>
                </div>
            )}
        </div>
    );
}
